import { render, staticRenderFns } from "./LoginDetails.vue?vue&type=template&id=511c4c48&scoped=true"
import script from "./LoginDetails.vue?vue&type=script&lang=js"
export * from "./LoginDetails.vue?vue&type=script&lang=js"
import style0 from "./LoginDetails.vue?vue&type=style&index=0&id=511c4c48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511c4c48",
  null
  
)

export default component.exports